import { useApp } from "../contexts/AppContext";
import { Navigate, Outlet } from "react-router-dom";

export default function AuthLayout() {
  const { isAuthenticated } = useApp();

  // 認証済みの場合はダッシュボードへリダイレクト
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}


